import React from "react";
import LpCta from "./LpCta";
import { ETAPAS } from "./lpData";

const LpAcompanhamento = () => (
  <section
    className="section-pad relative bg-black text-white bg-cover bg-center"
    style={{ backgroundImage: "url(/assets/lp-acompanhamento-bg.jpg)" }}
    data-testid="lp-acompanhamento"
  >
    <div className="absolute inset-0 bg-black/70" aria-hidden="true" />
    <div className="aevos-container relative">
      <div className="max-w-3xl">
        <h2 className="font-display font-bold text-3xl md:text-5xl !text-white leading-[1.08]">
          Seu plano precisa acompanhar sua evolução
        </h2>
        <p className="mt-5 text-white/85 text-base md:text-lg leading-relaxed">
          Depois da avaliação inicial, o Dr. Guilherme poderá indicar uma modalidade de
          acompanhamento AEVOS adequada às suas necessidades.
        </p>
      </div>

      <ol className="mt-12 grid md:grid-cols-3 gap-5" data-testid="lp-etapas">
        {ETAPAS.map((e, i) => (
          <li key={e.title} className="bg-white border border-[#E0E0E0] p-7 relative">
            <span className="absolute top-0 left-0 h-1 w-12 bg-[#00C4FF]" aria-hidden="true" />
            <span className="aevos-eyebrow">Etapa {i + 1}</span>
            <h3 className="font-display font-semibold text-lg md:text-xl mt-3">{e.title}</h3>
            <p className="mt-3 text-[#333333] text-sm md:text-base leading-relaxed">{e.text}</p>
          </li>
        ))}
      </ol>

      <div className="mt-12">
        <LpCta location="acompanhamento">Agendar minha consulta inicial</LpCta>
      </div>
    </div>
  </section>
);

export default LpAcompanhamento;
